import { formatDateTimeTz } from '../molecules/invoicing/utils/date-formatting.util';
import { i18n } from './i18n';

const disputeTooltipLabels = i18n.invoice.dispute;

/** Fields aligned with Payment entity / DTO dispute snapshot (pricing_ms). */
export interface IDisputeSnapshotInput {
	disputeStatus?: string;
	disputeReason?: string;
	disputeAmount?: number;
	disputeUpdatedAt?: string;
	disputeCreatedAt?: string;
}

/**
 * Builds a single tooltip string for invoice payment dispute snapshot fields.
 * @param input - The input object containing the dispute snapshot fields.
 * @param organizationTimezone - The timezone of the organization.
 * @returns A string containing the dispute tooltip content.
 * if the dispute status is not provided, return undefined (no tooltip, helps with visibility control)
 */
export function buildDisputeTooltipContent(
	input: IDisputeSnapshotInput,
	organizationTimezone: string
): undefined | string {
	if (!input.disputeStatus) {
		return undefined;
	}

	const lines: string[] = [];

	const stageLabel =
		disputeTooltipLabels.stages[input.disputeStatus] ?? disputeTooltipLabels.fallbackStage(input.disputeStatus);
	lines.push(stageLabel);


	if (input.disputeReason) {
		const reasonText =
			disputeTooltipLabels.reasons[input.disputeReason] ??
			disputeTooltipLabels.fallbackReason(input.disputeReason);
		lines.push(`${disputeTooltipLabels.reasonPrefix}: ${reasonText}`);
	}

		lines.push(disputeTooltipLabels.amountLabel(input.disputeAmount));

	const formatDate = formatDateTimeTz(organizationTimezone).formatDate;

	if (input.disputeCreatedAt) {
		lines.push(disputeTooltipLabels.created(formatDate(input.disputeCreatedAt)));
	}

	if (input.disputeUpdatedAt) {
		lines.push(disputeTooltipLabels.updated(formatDate(input.disputeUpdatedAt)));
	}

	return lines.join('\n');
}
